import Alterna from "../../../assets/images/brands/logo-alterna.svg?react";
import Authentic from "../../../assets/images/brands/logo-authentic-beauty-concept.svg?react";
import Deva from "../../../assets/images/brands/logo-deva-curl.svg?react";
import Joico from "../../../assets/images/brands/logo-joico.svg?react";
import Kenra from "../../../assets/images/brands/logo-kenra-professional.svg?react";
import Mydentiy from "../../../assets/images/brands/logo-mydentiy.svg?react";
import Pravana from "../../../assets/images/brands/logo-pravana.svg?react";
import Schwarzkopf from "../../../assets/images/brands/logo-schwarzkopf.svg?react";
import Sexyhair from "../../../assets/images/brands/logo-sexyhair.svg?react";
import Stmnt from "../../../assets/images/brands/logo-stmnt.svg?react";
// import Zotos from "../../../assets/images/brands/logo-zotos.svg?react";

export const brandPreferences = [
  { value: "alterna", label: "Alterna", icon: <Alterna /> },
  // { value: "authentic", label: "Authentic", icon: <Authentic /> },
  { value: "deva", label: "Deva", icon: <Deva /> },
  { value: "joico", label: "Joico", icon: <Joico /> },
  { value: "kenra", label: "Kenra", icon: <Kenra /> },
  // { value: "mydentiy", label: "Mydentiy", icon: <Mydentiy /> },
  { value: "pravana", label: "Pravana", icon: <Pravana /> },
  { value: "schwarzkopf", label: "Schwarzkopf", icon: <Schwarzkopf /> },
  { value: "sexyhair", label: "Sexyhair", icon: <Sexyhair /> },
  { value: "stmnt", label: "Stmnt", icon: <Stmnt /> },
  // { value: "zotos", label: "Zotos", icon: <Zotos /> },
];

export const businessType = [
  {
    value: "barberShop",
    label: "Barber Shop",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M9.269 8.635a10.114 10.114 0 0 1-1.139-.98l-.129-.129-.134.133c-.355.353-.736.679-1.139.976a6.15 6.15 0 0 1-3.386 1.375 2.776 2.776 0 0 1-1.995-.807A5.533 5.533 0 0 1 .009 6.528a.437.437 0 0 1 .185-.467h.009a.43.43 0 0 1 .494.033 2.608 2.608 0 0 0 1.688.511 10.97 10.97 0 0 0 2.134-.298l.051-.008a10.94 10.94 0 0 1 2.077-.284c.467-.015.93.085 1.35.291a2.83 2.83 0 0 1 1.35-.291 11.05 11.05 0 0 1 2.072.284l.043.008c.704.169 1.422.269 2.145.298a2.605 2.605 0 0 0 1.689-.511.438.438 0 0 1 .503-.033.431.431 0 0 1 .184.473 5.512 5.512 0 0 1-1.337 2.669 2.792 2.792 0 0 1-1.995.807 6.141 6.141 0 0 1-3.382-1.375Zm-.606-1.671c.368.374.767.718 1.191 1.027a5.254 5.254 0 0 0 2.807 1.152c.97 0 1.707-.624 2.188-1.852a4.17 4.17 0 0 1-1.241.176 11.869 11.869 0 0 1-2.322-.314l-.034-.008a10.327 10.327 0 0 0-1.9-.267 2.463 2.463 0 0 0-.689.088v-.002Zm-5.32 2.178a5.252 5.252 0 0 0 2.806-1.151c.427-.307.825-.65 1.191-1.027a2.417 2.417 0 0 0-.687-.087c-.641.029-1.277.118-1.9.266l-.043.008a11.83 11.83 0 0 1-2.317.314 4.123 4.123 0 0 1-1.238-.176c.483 1.247 1.207 1.853 2.187 1.853h.001Z"
        />
      </svg>
    ),
  },
  {
    value: "multipleLocations",
    label: "Multiple Locations",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M7.595 15.001 3.237 9.175a5.42 5.42 0 0 1-.744-2.729 5.48 5.48 0 0 1 5.5-5.447 5.477 5.477 0 0 1 5.5 5.447 5.398 5.398 0 0 1-.739 2.729l-.032.047-4.326 5.779h-.801Zm-4.1-8.555a4.369 4.369 0 0 0 .591 2.2l3.717 4.963h.388l3.716-4.963a4.4 4.4 0 0 0 .586-2.2 4.477 4.477 0 0 0-4.5-4.445 4.478 4.478 0 0 0-4.498 4.447v-.002Zm1.745.111a2.754 2.754 0 0 1 5.507 0 2.755 2.755 0 0 1-2.756 2.746A2.754 2.754 0 0 1 5.244 6.56l-.004-.003Zm1 0a1.751 1.751 0 0 0 3.504 0 1.754 1.754 0 0 0-1.754-1.75A1.751 1.751 0 0 0 6.246 6.56l-.006-.003Z"
        />
      </svg>
    ),
  },
  {
    value: "chairRenter",
    label: "Chair Renter",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M11.34 14.18a.333.333 0 0 1-.314-.2l-1.51-3.283H6.497l-1.51 3.287a.333.333 0 0 1-.313.2H3.51a.346.346 0 0 1-.286-.166.4.4 0 0 1-.037-.332v-.014l1.371-3.006a1.173 1.173 0 0 1-1.062-1.168v-.084a1.165 1.165 0 0 1 .817-1.117l-.956-4.893a1.27 1.27 0 0 1 .272-1.09 1.344 1.344 0 0 1 1.021-.477 1.334 1.334 0 0 1 1.292 1.066l1.057 5.359h4.316a1.174 1.174 0 0 1 1.173 1.174v.082c0 .605-.46 1.111-1.062 1.168l1.376 3.025a.435.435 0 0 1 0 .285.331.331 0 0 1-.3.189l-1.162-.005Zm.217-.7h.4l-1.27-2.789h-.4l1.27 2.789Zm-7.492 0h.392l1.27-2.789h-.392l-1.27 2.789Zm.138-4.049v.082a.47.47 0 0 0 .471.471h6.647a.469.469 0 0 0 .471-.471v-.082c0-.26-.211-.47-.471-.471H4.674a.473.473 0 0 0-.471.472v-.001Zm-.032-6.672a.592.592 0 0 0-.115.508v.014l.979 4.977h1.261l-1.03-5.221a.638.638 0 0 0-.614-.5.601.601 0 0 0-.485.221l.004.001Z"
        />
      </svg>
    ),
  },
  {
    value: "homeSalon",
    label: "Home Salon",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M8.455 2h-.91L4.764 4.764 4.5 4.5v-1h-1V6h.02L2 7.511V14h12V7.5L8.455 2ZM7.5 13v-3h1v3h-1Zm5.5 0H9.5V9h-3v4H3V7.927l4.6-4.573h.8L13 7.916V13Z"
        />
      </svg>
    ),
  },
  {
    value: "salon",
    label: "Salon",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M5.4 15.151a.431.431 0 0 1-.445-.445.432.432 0 0 1 .445-.441h2.21v-3a6.344 6.344 0 0 1-4.014-1.812 6.27 6.27 0 0 1-1.849-4.158.449.449 0 0 1 .445-.473h1.492A4.4 4.4 0 0 1 8.05.855a4.4 4.4 0 0 1 4.371 3.939h1.493a.447.447 0 0 1 .445.467v.01a6.314 6.314 0 0 1-1.849 4.182 6.326 6.326 0 0 1-4.014 1.816v3h2.183a.428.428 0 0 1 .44.441.428.428 0 0 1-.44.445L5.4 15.151ZM4.389 9.005a5.377 5.377 0 0 0 3.634 1.408 5.433 5.433 0 0 0 3.657-1.408 5.43 5.43 0 0 0 1.748-3.3h-1.006a4.4 4.4 0 0 1-4.371 3.963 4.383 4.383 0 0 1-3.008-1.191 4.46 4.46 0 0 1-1.386-2.771H2.651A5.54 5.54 0 0 0 4.39 9.007l-.001-.002Zm1.177-6.234a3.495 3.495 0 0 0 0 4.974A3.512 3.512 0 0 0 8.05 8.782a3.515 3.515 0 0 0 2.489-1.037 3.5 3.5 0 0 0 0-4.974 3.493 3.493 0 0 0-4.972.002l-.001-.002Zm.6 4.432a.428.428 0 0 1 0-.622L8.34 4.407a.514.514 0 0 1 .311-.107.41.41 0 0 1 .292.121.445.445 0 0 1 .134.311.454.454 0 0 1-.134.311l-2.16 2.16a.432.432 0 0 1-.614.002l-.003-.002ZM5.077 6.049a.381.381 0 0 1-.153-.283.456.456 0 0 1 .135-.352l3.147-3.152a.447.447 0 0 1 .311-.129.447.447 0 0 1 .311.129.431.431 0 0 1 0 .621L5.676 6.035a.421.421 0 0 1-.3.125.489.489 0 0 1-.295-.109l-.004-.002Z"
        />
      </svg>
    ),
  },
];

export const specialityInterest = [
  {
    value: "barberShop",
    label: "Barber Shop",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M9.269 8.635a10.114 10.114 0 0 1-1.139-.98l-.129-.129-.134.133c-.355.353-.736.679-1.139.976a6.15 6.15 0 0 1-3.386 1.375 2.776 2.776 0 0 1-1.995-.807A5.533 5.533 0 0 1 .009 6.528a.437.437 0 0 1 .185-.467h.009a.43.43 0 0 1 .494.033 2.608 2.608 0 0 0 1.688.511 10.97 10.97 0 0 0 2.134-.298l.051-.008a10.94 10.94 0 0 1 2.077-.284c.467-.015.93.085 1.35.291a2.83 2.83 0 0 1 1.35-.291 11.05 11.05 0 0 1 2.072.284l.043.008c.704.169 1.422.269 2.145.298a2.605 2.605 0 0 0 1.689-.511.438.438 0 0 1 .503-.033.431.431 0 0 1 .184.473 5.512 5.512 0 0 1-1.337 2.669 2.792 2.792 0 0 1-1.995.807 6.141 6.141 0 0 1-3.382-1.375Zm-.606-1.671c.368.374.767.718 1.191 1.027a5.254 5.254 0 0 0 2.807 1.152c.97 0 1.707-.624 2.188-1.852a4.17 4.17 0 0 1-1.241.176 11.869 11.869 0 0 1-2.322-.314l-.034-.008a10.327 10.327 0 0 0-1.9-.267 2.463 2.463 0 0 0-.689.088v-.002Zm-5.32 2.178a5.252 5.252 0 0 0 2.806-1.151c.427-.307.825-.65 1.191-1.027a2.417 2.417 0 0 0-.687-.087c-.641.029-1.277.118-1.9.266l-.043.008a11.83 11.83 0 0 1-2.317.314 4.123 4.123 0 0 1-1.238-.176c.483 1.247 1.207 1.853 2.187 1.853h.001Z"
        />
      </svg>
    ),
  },
  {
    value: "blonding",
    label: "Blonding",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="m11.923.6-.654 12.188h-.747v1.167a1.415 1.415 0 0 1-1.4 1.448H6.878a1.415 1.415 0 0 1-1.4-1.448v-1.167h-.746L4.078.6h7.845ZM5.012 2.141h5.977l.047-.654H5.012v.654Zm5.93.841H5.059l.514 8.966h4.856l.513-8.966Zm-1.264 9.806H6.319v1.167a.568.568 0 0 0 .56.56h2.242a.568.568 0 0 0 .56-.56l-.003-1.167Z"
        />
      </svg>
    ),
  },
  {
    value: "bridalUpdo",
    label: "Bridal/Updo",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="m2.027 14.906-.643-.236.648-.234c.47-.172.847-.531 1.042-.991.137-.283.202-.595.188-.91a1.98 1.98 0 0 1-.437.352 1.186 1.186 0 0 1-1.145.137l-.5-.225.5-.23a1.77 1.77 0 0 0 .812-.666 3.16 3.16 0 0 0 .226-2.2 24.228 24.228 0 0 0-.329-1.154c-.15-.512-.253-.91-.31-1.2a6.132 6.132 0 0 1 .23-3.506v-.006a5.033 5.033 0 0 1 .972-1.5A4.414 4.414 0 0 1 4.745 1.29 3.842 3.842 0 0 1 6.524.972a3.653 3.653 0 0 1 1.587.436c.454-.276.98-.411 1.511-.389.592.014 1.17.177 1.68.475a5.22 5.22 0 0 1 2.084 2.633c.353.829.526 1.723.507 2.623-.017.474-.064.947-.141 1.414l-.267 1.701c0 .046-.024.146-.1.478a1.652 1.652 0 0 0-.061.424.53.53 0 0 0 .127.322.174.174 0 0 0 .112.033.479.479 0 0 0 .183-.037l.437-.164-.1.455a1.165 1.165 0 0 1-.174.401 1.147 1.147 0 0 1-1.047.572.37.37 0 0 0 .207.099c.158.022.317.022.474 0 .202-.048.397-.119.582-.211l.38-.173-.023.418a1.332 1.332 0 0 1-.343.844 1.223 1.223 0 0 1-.6.377c-.2.056-.407.087-.615.094.043.049.088.096.136.141.203.169.423.315.657.436l.366.207-.357.221a1.559 1.559 0 0 1-1.746-.08 3.308 3.308 0 0 1-1.141-1.281 3.542 3.542 0 0 1-.273-.725 7.41 7.41 0 0 1-.506.471 3.169 3.169 0 0 1-2.027.869 3.21 3.21 0 0 1-2.01-.818 1.7 1.7 0 0 1-.585 1.166l-.413.355v-.75a2.622 2.622 0 0 0-.075-.395 1.128 1.128 0 0 0-.1-.244 2.16 2.16 0 0 1-.72 1.235h-.014a2.177 2.177 0 0 1-1.324.441 2.246 2.246 0 0 1-.765-.14Zm4.567-2.5c.388.371.892.595 1.427.634a2.215 2.215 0 0 0 1.384-.634 8.778 8.778 0 0 0 1.055-1.092c.051-.485.171-.959.358-1.408.268-.672.343-.85.361-.906a1.28 1.28 0 0 0 .047-.752l-.4-.006a2.862 2.862 0 0 1-1.53-.5 4.44 4.44 0 0 1-.643-.509c.065.17.155.328.268.469l.395.494-.625-.09a3.056 3.056 0 0 1-1.995-1.168 3.19 3.19 0 0 1-.662-1.352c-.238.465-.42.956-.544 1.463a6.36 6.36 0 0 0-.1 2.357c.038.262.122.662.249 1.178.131.531.221.939.268 1.2v.01l.024.182c.359.226.638.411.663.432v-.002Z"
        />
      </svg>
    ),
  },
  {
    value: "curlyOrTexturedHair",
    label: "Curly or Textured Hair",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M6.529 13.861a11.463 11.463 0 0 1-1.333-1.6 6.379 6.379 0 0 1-1.129-2.8l-.016.018a.38.38 0 0 1-.075.08l-.014.01a.962.962 0 0 1-.155.3.127.127 0 0 1-.061.01.809.809 0 0 1-.253-.047 1.038 1.038 0 0 1-.526-.5 1.28 1.28 0 0 1-.108-.3c-.058 0-.116-.004-.173-.014a.713.713 0 0 1-.488-.4.844.844 0 0 1-.071-.559 1.02 1.02 0 0 1 .216-.479.58.58 0 0 1-.6-.408.53.53 0 0 1 .047-.451.694.694 0 0 1 .277-.281l.019-.01c.014-.01.028-.014.042-.023a2.113 2.113 0 0 1-.216-.207c-.183-.2-.418-.508-.314-.8a.96.96 0 0 1 .31-.418.017.017 0 0 0 0-.014.786.786 0 0 1-.165-.541.841.841 0 0 1 .188-.512c.114-.14.263-.248.432-.314h.009c.149-.05.308-.067.465-.047a.808.808 0 0 1 .038-.174c.074-.225.223-.417.423-.545a1.748 1.748 0 0 1 1.112-.2h.165a.618.618 0 0 1 .113-.428.881.881 0 0 1 .751-.328h.023c.147.019.291.058.427.117l.014-.037a.768.768 0 0 1 .483-.475c.393-.093.806.031 1.084.324l.014.014c.028.033.141.15.329.348 0 0 0 .01.01.01.03-.112.072-.22.126-.324l.009-.014c.085-.136.201-.25.338-.334a.818.818 0 0 1 .474-.127l.028.01a.798.798 0 0 1 .5.291.888.888 0 0 1 .1-.164.72.72 0 0 1 .432-.311.614.614 0 0 1 .544.09h.009c.136.12.227.283.258.461a.74.74 0 0 1 .4-.127c.189.006.37.076.512.2a.917.917 0 0 1 .3.418c.035.077.04.164.014.244a.693.693 0 0 1 .61.094.958.958 0 0 1 .357.5.618.618 0 0 1 .474.018.71.71 0 0 1 .413.4c.078.169.113.354.1.539a1.636 1.636 0 0 1-.089.475c.09.023.177.056.258.1l.009.014a.862.862 0 0 1 .432.666c.027.26-.036.52-.179.738a1.622 1.622 0 0 1-.268.338c.068.111.116.233.141.361.047.222.032.452-.042.666v.01c-.086.214-.24.394-.437.512-.009.01-.023.01-.033.02a.959.959 0 0 1 .165.4c.028.16-.01.4-.362.605a.658.658 0 0 1-.375.127.837.837 0 0 1-.507.221.238.238 0 0 1-.084-.012 6.464 6.464 0 0 1-1.155 2.984 11.254 11.254 0 0 1-1.329 1.6c-.441.48-1.05.772-1.7.816a2.623 2.623 0 0 1-1.737-.824ZM4.477 8.48a6.17 6.17 0 0 0 1.122 3.488c.376.546.802 1.057 1.272 1.525.36.393.854.636 1.385.682a2.063 2.063 0 0 0 1.362-.682c.466-.467.888-.976 1.263-1.52a6.097 6.097 0 0 0 1.1-3.143.883.883 0 0 1-.209-.482 1.151 1.151 0 0 1 .066-.578.863.863 0 0 1-.329.3.627.627 0 0 1-.427.061.536.536 0 0 1-.348-.291.487.487 0 0 1-.042-.422.31.31 0 0 1-.291.188.43.43 0 0 1-.371-.137.62.62 0 0 1-.178-.361.97.97 0 0 1 .009-.422 1.626 1.626 0 0 1-.352.559.518.518 0 0 1-.573.141.522.522 0 0 1-.263-.291.855.855 0 0 1-.033-.408.846.846 0 0 1-.488.549.742.742 0 0 1-.7-.01 1.459 1.459 0 0 1-.084-.816.972.972 0 0 1-.658.615.731.731 0 0 1-.338.07.218.218 0 0 1-.15-.113.162.162 0 0 1-.042-.154 5.541 5.541 0 0 0-.141.535c-.084.221-.211.334-.38.334-.127 0-.268-.127-.423-.381a.978.978 0 0 1-.164.5.364.364 0 0 1-.423.145c-.059.174-.116.338-.17.492-.003.005-.002.017-.002.027Z"
        />
      </svg>
    ),
  },
  {
    value: "hairdresserCutter",
    label: "Hairdresser & Cutter",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M6.006 14.168a5.499 5.499 0 0 1-.391-.359 7.287 7.287 0 0 1-1.561-.371 3.792 3.792 0 0 1-1.707-1.25 4.837 4.837 0 0 1-.924-2.094 11.392 11.392 0 0 1-.17-2.281c.018-.79.153-1.573.4-2.324A7.457 7.457 0 0 1 2.77 3.368 5.975 5.975 0 0 1 4.496 1.85a6.261 6.261 0 0 1 2.2-.787 8.078 8.078 0 0 1 2.282-.043 6.057 6.057 0 0 1 4.172 2.438 7.852 7.852 0 0 1 1.6 4.672 7.75 7.75 0 0 1-.519 2.994 2.969 2.969 0 0 1-.275.574 4.078 4.078 0 0 1-2.079 1.563 1.847 1.847 0 0 1-.729.191l-.424.1c-.203.22-.421.426-.651.617a3.16 3.16 0 0 1-2.013.871 3.267 3.267 0 0 1-2.054-.872Zm-2-6.449c-.035.493.019.988.16 1.461v.014a6.178 6.178 0 0 0 1.561 2.523c.208.217.476.471.792.744.188.16.476.41.858.727l.335.283-.419.146a4.276 4.276 0 0 1-.929.2c.467.43 1.067.686 1.7.727a2.697 2.697 0 0 0 1.693-.756 2.67 2.67 0 0 0 .165-.141 3.01 3.01 0 0 1-.7-.094l-.486-.123.392-.316a7.37 7.37 0 0 0 1.188-1.187c.524-.63.988-1.309 1.385-2.027.121-.374.198-.762.232-1.154.028-.26.042-.529.052-.807a2.848 2.848 0 0 0-.043-.611c-.152-.008-.862.025-1.583.055-.834.037-1.688.08-1.707.057l-.047.16-.193-.01c-.368-.01-.948-.018-1.711-.018a.895.895 0 0 1-.613-.193l-.033.107-.184.006a46.01 46.01 0 0 1-1.527.031h-.217l-.028-.217a.95.95 0 0 0-.019-.117 4.734 4.734 0 0 0-.078.53h.004Z"
        />
      </svg>
    ),
  },
  {
    value: "hairdressColorist",
    label: "Hairdress & Colorist",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M11.295 9.75c.018-.325.024-.618.018-.877a2.274 2.274 0 0 0-1.175-1.935l.362.759c.105.254.228.501.368.738A35.521 35.521 0 0 1 8.111 6.22l.045.127c.035.11.087.214.154.307.144.206.301.402.47.588l-.003.003.407.443A12.653 12.653 0 0 1 7.9 6.929a7.537 7.537 0 0 1-2.51-2.984 8.786 8.786 0 0 0-.19.452 25.91 25.91 0 0 1-1.418 2.796l.002.134c0 1.4 1.425 4.011 1.97 4.764a3.228 3.228 0 0 0 2.58 1.285c.707 0 2.117-1.591 2.79-1.953a.572.572 0 0 1 .004-.092l.003-.003a.554.554 0 0 1 .035-.143c.046-.394.091-.889.131-1.438l-.002.003Zm-5.056 4.181a7.917 7.917 0 0 1-.127 1.2 1.076 1.076 0 0 1-.47-.3l-.452-.452c-.036.115-.057.169-.063.163l-.108.334a1.202 1.202 0 0 1-.172.253 1.56 1.56 0 0 1-.705.362v-.434a1.18 1.18 0 0 0-.045-.334l-.027-.063-.063-.009c-.148.2-.34.364-.561.479-.22.111-.459.182-.705.208l.434-.868c.112-.303.158-.627.136-.949-.012.067-.09.136-.235.208a1.576 1.576 0 0 1-.307.108 2.443 2.443 0 0 1-1.266-.181c.381-.115.711-.354.94-.678.236-.327.366-.718.371-1.121a.447.447 0 0 1-.452.154 1.17 1.17 0 0 1-.479-.181c-.06-.018-.09-.048-.09-.09l.253-.09a.654.654 0 0 0 .362-.38l.154-.5a10.06 10.06 0 0 0 .226-1.926v-.018H2.77c-.03-.41-.054-.666-.072-.768l-.063-1.076.063-.913.018-.072.054-.38a6.324 6.324 0 0 1 .561-1.672c.259-.527.56-1.032.9-1.51.162-.21.341-.406.533-.588a3.89 3.89 0 0 1 .9-.633l.2-.1a.613.613 0 0 1 .19-.081c.187-.091.381-.167.579-.226a6.42 6.42 0 0 1 .814-.226l.38-.072h.036l.181.027.009-.027c.085.012.221.027.407.045l.19.027a7.206 7.206 0 0 1 1.582.533 4.2 4.2 0 0 1 1.627 1.32c.353.475.661.98.922 1.51.255.53.438 1.093.542 1.672.115.58.154 1.173.118 1.763a23.687 23.687 0 0 1-.163 1.727 1.294 1.294 0 0 1-.045.262c.036.4.106.867.208 1.4l.154.5a.66.66 0 0 0 .362.38l.253.09h.001c0 .042-.03.072-.091.091a1.16 1.16 0 0 1-.479.181.449.449 0 0 1-.452-.154c.008.404.141.796.38 1.121.221.329.551.57.931.678-.398.17-.835.232-1.265.178a1.237 1.237 0 0 1-.3-.108c-.15-.072-.232-.141-.244-.208-.021.322.025.646.136.949l.434.868a2.056 2.056 0 0 1-.705-.208 2.013 2.013 0 0 1-.542-.434.045.045 0 0 1 0 .054l-.063-.1-.027.009-.018.063c-.03.109-.045.221-.045.334v.434a1.57 1.57 0 0 1-.705-.362.844.844 0 0 1-.163-.253l-.127-.334c0 .025-.015-.03-.045-.163-.036.03-.189.181-.461.452-.123.14-.282.244-.461.3a6.903 6.903 0 0 1-.127-1.2 2.363 2.363 0 0 1 .176-.963l-.028.025a2.47 2.47 0 0 1-1.586.751 5.64 5.64 0 0 1-2.276-.775c.123.307.184.635.181.967Z"
        />
      </svg>
    ),
  },
  {
    value: "creativeColor",
    label: "Creative Color",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M12.759 6.824 8.4.999h-.8L3.268 6.777l-.032.048A5.417 5.417 0 0 0 2.5 9.551c0 4.234 4.584 6.88 8.25 4.763a5.499 5.499 0 0 0 2.75-4.763 5.403 5.403 0 0 0-.741-2.727ZM8 14a4.48 4.48 0 0 1-4.5-4.449c0-.772.202-1.531.587-2.2L7.8 2.39h.385l3.719 4.963c.387.669.591 1.428.591 2.2A4.48 4.48 0 0 1 8 14Z"
        />
      </svg>
    ),
  },
  {
    value: "wigExtensions",
    label: "Wig / Extensions",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M5.564 14.339c-2.275-3.088-2.437-4.713-.812-7.475a8.87 8.87 0 0 0 .975 4.55 8.306 8.306 0 0 1 .813-6.5c.813 1.625 1.788 1.788 3.9 2.925 2.925 1.787 1.3 3.9-.65 6.825a7.31 7.31 0 0 0 4.711-6.987c0-3.087-2.762-6.337-6.012-6.337a4.007 4.007 0 0 0-3.737 2.112c-2.113.162-3.25 2.275-3.25 4.225 0 3.737 1.285 4.58 4.063 6.663l-.001-.001Z"
        />
      </svg>
    ),
  },
];

export const educationInterest = [
  {
    value: "salonBusiness",
    label: "Salon Business",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M1.162 14.503v-13h1.265V12.64l.6.605H14.84v1.26l-13.678-.002Zm3.677-4.871 3.662-3.666 1.954 1.953 3.459-3.889.689.684-4.148 4.668-1.954-1.949-2.926 2.932-.736-.733Z"
        />
      </svg>
    ),
  },
  {
    value: "socialMedia",
    label: "Social Media",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M11.02 2.583A3.448 3.448 0 0 0 8.3 3.921h-.6a3.45 3.45 0 0 0-2.721-1.338A3.514 3.514 0 0 0 1.5 6.122a3.562 3.562 0 0 0 .891 2.36l5.37 4.935h.477l5.33-4.894.04-.041a3.568 3.568 0 0 0 .892-2.36 3.514 3.514 0 0 0-3.48-3.539Zm1.8 5.142-4.175 3.833H7.354L3.179 7.725a2.455 2.455 0 0 1-.6-1.6 2.418 2.418 0 0 1 2.4-2.442 2.382 2.382 0 0 1 2 1.092l.161.246h1.724l.161-.246a2.382 2.382 0 0 1 2-1.092 2.418 2.418 0 0 1 2.4 2.437 2.456 2.456 0 0 1-.605 1.605Z"
        />
      </svg>
    ),
  },
  {
    value: "photography",
    label: "Photography",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="m12.509 3.926-1.25 1.258-.258-.258v-2h-10v10h10v-2l.222-.222 1.295 1.222h2.483v-8h-2.492Zm-2.508 8h-8v-8h8v8Zm4-1h-1.085l-1.915-1.808V6.864l1.924-1.938h1.076v6Z"
        />
      </svg>
    ),
  },
  {
    value: "color",
    label: "Color",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M12.759 6.824 8.4.999h-.8L3.268 6.777l-.032.048A5.414 5.414 0 0 0 2.5 9.551c0 4.234 4.584 6.88 8.25 4.763a5.5 5.5 0 0 0 2.75-4.763c0-.959-.256-1.9-.741-2.727ZM8 14a4.48 4.48 0 0 1-4.5-4.449c0-.772.202-1.531.587-2.2L7.8 2.39h.385l3.719 4.963c.387.668.591 1.427.591 2.2A4.48 4.48 0 0 1 8 14Z"
        />
      </svg>
    ),
  },
  {
    value: "cut",
    label: "Cut",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M1.5 12.207a2.645 2.645 0 0 1 4.093-2.209l1.992-1.994-1.993-1.992a2.62 2.62 0 0 1-1.447.432A2.647 2.647 0 0 1 1.5 3.799a2.65 2.65 0 0 1 2.645-2.646A2.648 2.648 0 0 1 6.79 3.799a2.615 2.615 0 0 1-.43 1.443l1.993 1.994 5.224-5.227a.541.541 0 0 1 .765 0 .547.547 0 0 1 0 .77L8.737 8.384l-2.378 2.379c.282.428.432.93.431 1.443a2.647 2.647 0 0 1-2.645 2.645A2.647 2.647 0 0 1 1.5 12.207Zm1.085 0c0 .862.698 1.562 1.56 1.564a1.564 1.564 0 0 0 1.559-1.564 1.559 1.559 0 0 0-3.119 0Zm0-8.408a1.56 1.56 0 1 0 3.118 0 1.56 1.56 0 0 0-3.118 0Zm10.992 10.2L9.698 10.13a.543.543 0 0 1 0-.766.538.538 0 0 1 .765 0l3.879 3.869a.543.543 0 0 1-.382.924.536.536 0 0 1-.383-.161v.003Z"
        />
      </svg>
    ),
  },
  {
    value: "styling",
    label: "Styling",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M6.777 15.908a.506.506 0 0 1-.253-.307.503.503 0 0 1 .048-.387l.479-.885-.249-.139a.518.518 0 0 1-.249-.307.52.52 0 0 1 .043-.387l2.1-3.871c-.134-.172-.3-.377-.541-.641-.8-.9-3.287-2.975-4.219-3.76a10.613 10.613 0 0 1-.234-.191l-2.086.158a.504.504 0 0 1-.44-.25.512.512 0 0 1 0-.5L3.42.304a.507.507 0 0 1 .45-.27h.009a.506.506 0 0 1 .436.283l.947 1.736a34.889 34.889 0 0 0 5.836 1.584c.739.015 1.465.19 2.129.512h.014a3.172 3.172 0 0 1 1.56 2.092v.043c.187.911.045 1.86-.4 2.678a3.903 3.903 0 0 1-2.057 1.8 3.398 3.398 0 0 1-1.134.205c-.091 0-.177 0-.268-.014l-2.062 3.8a.509.509 0 0 1-.306.248l-.019.01h-.024a.405.405 0 0 1-.11 0 .472.472 0 0 1-.234-.066l-.249-.135-.483.891a.506.506 0 0 1-.445.268.503.503 0 0 1-.233-.061Zm.957-2.373.5.273 1.713-3.133a4.034 4.034 0 0 1-.187-.092 2.742 2.742 0 0 1-.321-.191l-1.705 3.143ZM4.462 4.342a58.625 58.625 0 0 1 4.449 3.961c.268.3.45.531.593.713l.048.057c.172.257.406.468.679.613.311.165.658.251 1.009.252.261 0 .519-.049.761-.143a2.8 2.8 0 0 0 1.425-1.172l.091-.158a2.82 2.82 0 0 0 .287-1.99 2.141 2.141 0 0 0-1.047-1.42 4.106 4.106 0 0 0-1.693-.412 33.658 33.658 0 0 1-5.913-1.559l-.689 1.258Zm-1.937-.23.947-.076.856-1.584-.459-.842-1.344 2.502Z"
        />
      </svg>
    ),
  },
  {
    value: "curlyHaircutStyling",
    label: "Curly Haircut & Styling",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M10.497 15.33a.3.3 0 0 1 .134-.4.836.836 0 0 0 .469-.426.51.51 0 0 0-.053-.389 3.51 3.51 0 0 0-.426-.588l-.009-.014a5.049 5.049 0 0 1-.21-.254 1.362 1.362 0 0 1-.244-.723 1.254 1.254 0 0 1 .191-.723 1.4 1.4 0 0 1 .55-.473l.009-.006a.91.91 0 0 0 .316-.248.652.652 0 0 0 .12-.387.727.727 0 0 0-.125-.412 2.218 2.218 0 0 0-.11-.135c-.024-.027-.053-.066-.086-.1a3.925 3.925 0 0 1-.507-.713c-.335-.674-.11-1.215.674-1.607a.86.86 0 0 0 .469-.426.533.533 0 0 0-.057-.4 3.477 3.477 0 0 0-.436-.594l-.019-.023-.191-.234a1.295 1.295 0 0 1-.244-.762 1.212 1.212 0 0 1 .229-.74c.136-.178.311-.322.512-.422a.846.846 0 0 0 .344-.277.706.706 0 0 0-.029-.77c-.043-.057-.105-.129-.167-.211l-.019-.023a3.745 3.745 0 0 1-.512-.713c-.334-.674-.11-1.215.68-1.607a.261.261 0 0 1 .134-.033.3.3 0 0 1 .263.162c.035.072.04.155.014.23a.268.268 0 0 1-.148.166c-.579.293-.531.574-.411.818.119.216.264.418.431.6.081.1.148.178.21.26a1.312 1.312 0 0 1 .053 1.444 1.345 1.345 0 0 1-.545.469v.006a.859.859 0 0 0-.325.254.639.639 0 0 0-.12.387.686.686 0 0 0 .129.406c.053.072.129.162.187.234l.019.023c.191.213.356.448.493.7.34.674.11 1.215-.674 1.607a.83.83 0 0 0-.464.426.514.514 0 0 0 .053.391c.124.212.27.411.435.594l.034.043c.062.072.124.148.177.221.159.222.246.487.249.76.002.266-.08.525-.234.742a1.522 1.522 0 0 1-.5.416h-.01a.921.921 0 0 0-.344.281.685.685 0 0 0-.1.379c.005.139.05.273.129.387.038.053.091.115.144.178l.048.057c.197.219.367.46.507.719.34.674.11 1.215-.679 1.607a.348.348 0 0 1-.134.033.292.292 0 0 1-.274-.167Zm-3.2-.115a.3.3 0 0 1 .158-.387.862.862 0 0 0 .488-.383.486.486 0 0 0-.024-.4 3.509 3.509 0 0 0-.4-.627l-.015-.023c-.067-.092-.129-.174-.187-.26a1.296 1.296 0 0 1-.2-.727 1.236 1.236 0 0 1 .794-1.143l.014-.01a.84.84 0 0 0 .34-.23.642.642 0 0 0 .144-.377.725.725 0 0 0-.105-.416 2.3 2.3 0 0 0-.139-.2l-.038-.053a3.878 3.878 0 0 1-.469-.756 1.08 1.08 0 0 1-.058-.836c.166-.341.466-.599.828-.713a.851.851 0 0 0 .488-.393.503.503 0 0 0-.033-.393 3.186 3.186 0 0 0-.388-.617l-.014-.02a4.637 4.637 0 0 1-.191-.268 1.292 1.292 0 0 1-.2-.77c.013-.267.109-.523.277-.732.144-.164.324-.293.526-.377l.01-.006a.939.939 0 0 0 .359-.254.708.708 0 0 0 .12-.373.76.76 0 0 0-.105-.4c-.048-.072-.11-.152-.177-.244l-.015-.023a3.591 3.591 0 0 1-.454-.732 1.048 1.048 0 0 1-.053-.842c.168-.34.467-.597.828-.713a.346.346 0 0 1 .115-.023.301.301 0 0 1 .272.182.293.293 0 0 1-.153.383c-.6.254-.569.535-.469.785.112.221.246.431.4.625l.019.02c.062.092.125.178.182.258.136.219.206.474.2.732a1.25 1.25 0 0 1-.234.713c-.15.195-.35.345-.579.436a.989.989 0 0 0-.334.23.636.636 0 0 0-.144.377.752.752 0 0 0 .1.422c.034.053.082.113.129.182l.048.066c.186.231.344.483.469.752.292.688.033 1.215-.771 1.555-.588.248-.56.535-.459.783.111.222.245.432.4.627.077.105.144.191.2.277.147.229.217.499.2.77a1.247 1.247 0 0 1-.277.729 1.42 1.42 0 0 1-.536.383.852.852 0 0 0-.354.258.667.667 0 0 0-.125.373.777.777 0 0 0 .1.4c.048.068.11.154.177.244.187.232.344.486.469.756.134.263.154.57.053.848a1.42 1.42 0 0 1-.828.707.293.293 0 0 1-.374-.152h-.005Zm-3.779-.354a.3.3 0 0 1 .2-.369.866.866 0 0 0 .521-.314.494.494 0 0 0 .024-.393 3.207 3.207 0 0 0-.335-.68l-.038-.066c-.043-.076-.086-.152-.129-.234a1.328 1.328 0 0 1-.124-.752c.032-.252.14-.489.311-.678.168-.174.379-.3.612-.365h.01a.93.93 0 0 0 .359-.187.609.609 0 0 0 .177-.357.763.763 0 0 0-.057-.432c-.039-.066-.091-.162-.153-.262v-.006a3.753 3.753 0 0 1-.392-.818c-.206-.713.11-1.2.938-1.434.6-.178.612-.461.536-.709a3.716 3.716 0 0 0-.334-.693 4.327 4.327 0 0 1-.167-.291 1.34 1.34 0 0 1-.115-.791c.04-.262.163-.505.35-.693.163-.147.358-.254.569-.314a.838.838 0 0 0 .383-.211.676.676 0 0 0 .158-.354.73.73 0 0 0-.062-.412c-.038-.072-.1-.178-.148-.264a3.594 3.594 0 0 1-.4-.822 1.054 1.054 0 0 1 .053-.838 1.4 1.4 0 0 1 .895-.6.375.375 0 0 1 .082-.01c.132 0 .247.088.282.215A.285.285 0 0 1 7.5.952a.281.281 0 0 1-.182.139.856.856 0 0 0-.517.316.475.475 0 0 0-.019.387c.084.244.199.477.34.693l.009.02c.053.1.105.178.153.273.114.232.156.494.12.75a1.187 1.187 0 0 1-.306.68c-.17.177-.385.305-.622.369a.807.807 0 0 0-.354.186.606.606 0 0 0-.182.359.715.715 0 0 0 .057.43c.029.059.077.135.125.217l.038.066c.159.251.287.519.383.8.206.713-.11 1.2-.937 1.441-.6.176-.612.453-.536.707.085.242.197.473.334.689.067.109.12.205.167.3.118.243.158.516.115.783a1.199 1.199 0 0 1-.354.693 1.37 1.37 0 0 1-.574.316.908.908 0 0 0-.378.211.644.644 0 0 0-.158.359c-.02.139.002.28.062.406.034.066.091.162.148.262.167.258.301.537.4.828.206.713-.115 1.191-.947 1.436a.3.3 0 0 1-.362-.207h-.005Z"
        />
      </svg>
    ),
  },
  {
    value: "permsWaves",
    label: "Perms & Waves",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M2.926 15.652a.711.711 0 0 1-.66-.465l-.249-.512.55.162c.038.016.086.025.1.01a.477.477 0 0 0 .086-.135.17.17 0 0 0 0-.109c-.02-.057-.043-.066-.053-.072l-.019-.01-.019-.014a.786.786 0 0 0-.239-.066.743.743 0 0 1-.44-.187c-.187-.182-.315-.525.134-1.09v-.01c.244-.283.278-.436.259-.484 0 0-.039-.07-.278-.186a1.84 1.84 0 0 1-.646-.469.923.923 0 0 1-.239-.814c.068-.235.201-.447.383-.611.124-.116.226-.253.3-.406a.361.361 0 0 0-.053-.373.76.76 0 0 0-.144-.139v-.006a1.99 1.99 0 0 1-.21-.191l-.014-.014a1.229 1.229 0 0 1-.282-.709 1.17 1.17 0 0 1 .191-.727c.104-.146.226-.278.363-.393.1-.084.187-.183.258-.293v-.008c.058-.091.08-.2.063-.307a.534.534 0 0 0-.129-.287 1.967 1.967 0 0 1-.469-.455l-.01-.014a.739.739 0 0 1-.024-.65c.07-.189.187-.357.34-.488.181-.127.371-.239.569-.336a.792.792 0 0 0 .363-.314.464.464 0 0 0 .029-.268c-.029-.072-.062-.207-.134-.465v-.01a1.077 1.077 0 0 1 .124-.822 1.06 1.06 0 0 1 .66-.512c.132-.032.265-.051.4-.059.11-.01.219-.027.326-.051l.019-.006a.481.481 0 0 0 .234-.135.566.566 0 0 0 .139-.258v-.02c0-.02.019-.092.062-.393a.953.953 0 0 1 .215-.512l.014-.01a.79.79 0 0 1 .512-.2h.01c.159.005.315.034.464.086h.01c.082.035.2.082.354.145a.83.83 0 0 0 .268.066 1.12 1.12 0 0 0 .454-.205c.187-.149.388-.279.6-.389a1.371 1.371 0 0 1 1.1.006c.284.113.538.29.742.516.178-.046.362-.068.545-.066a.659.659 0 0 1 .693.389.746.746 0 0 1 .082.242.188.188 0 0 0 .014.053.341.341 0 0 0 .134.02c.152-.016.306-.006.454.029a.87.87 0 0 1 .593.77c.019.1.034.225.053.4a.83.83 0 0 0 .1.281c.029.059.148.2.6.445.328.142.592.399.742.723v.006c.078.354.036.724-.12 1.051v.006a1.326 1.326 0 0 0-.148.713c.088.164.197.315.325.449.189.19.319.431.373.693.004.39-.139.767-.4 1.057-.263.393-.268.58-.253.652a.887.887 0 0 0 .158.225l.273.3.014.02c.223.338.254.767.082 1.133l-.019.049-.039.033c-.182.162-.325.3-.426.387a.314.314 0 0 0-.081.389.692.692 0 0 0 .167.1c.138.056.27.126.392.209l.014.01.01.016a.83.83 0 0 1 .215.469v.018c0 .078.009.211.009.418a.914.914 0 0 0 .163.582l.01.01a.18.18 0 0 0 .144.082.261.261 0 0 0 .2-.066l.421-.307-.024.516a.76.76 0 0 1-.22.5.854.854 0 0 1-.474.248.72.72 0 0 1-.354-.014l-.072.359a.75.75 0 0 1-.693.627 1.425 1.425 0 0 1-.809-.191.931.931 0 0 1-.56-.738 2.069 2.069 0 0 0-.058-.436.294.294 0 0 0-.268-.152l-.01.006a.884.884 0 0 1-.694-.254.821.821 0 0 1-.153-.92.94.94 0 0 0 .1-.42.582.582 0 0 0-.258-.268L10 11.722l-.967 1.02a2.905 2.905 0 0 1-1.851.8c-.47-.01-.93-.148-1.328-.4v.021a.88.88 0 0 1-.206.736 1.704 1.704 0 0 1-.144.174l-.014.018a.371.371 0 0 0 .024.049c.067.1.091.139.1.158l.019.023.019.043c.066.164.07.346.01.512a.86.86 0 0 1-.272.426l-.015.014a2.484 2.484 0 0 1-.344.23.855.855 0 0 1-.512.086l-.588-.086.469-.359a.38.38 0 0 0 .153-.219.196.196 0 0 0-.033-.164 3.048 3.048 0 0 1-.234-.248l-.01-.014a.742.742 0 0 1-.091-.574v-.025c.038-.127.068-.256.091-.387v-.01a.67.67 0 0 0-.072-.445v.006c-.06.101-.132.194-.215.277a.996.996 0 0 0-.129.186.711.711 0 0 0 0 .355c.044.19.067.384.067.578a1.366 1.366 0 0 1-.436.895.82.82 0 0 1-.569.264l.004-.01Zm10.256-1.373c.063.072.077.057.12.033l.268-.168a.862.862 0 0 1-.33-.307c-.101.241-.101.381-.058.442Zm-5.979-1.244a2.443 2.443 0 0 0 1.531-.684c.514-.458.983-.964 1.4-1.512a.774.774 0 0 1 .08-.082c.123-.194.228-.398.313-.611.3-.785-.05-1.514.58-1.6-.074-.039-.14-.078-.2-.113-.12.1-.2.164-.2.164a1.04 1.04 0 0 1-.363-.359v-.014a.943.943 0 0 1 0-.666c.1-.363.134-.469.139-.492a.626.626 0 0 0 0-.244l-.238.215a1.122 1.122 0 0 1-.933.258 1.934 1.934 0 0 1-.632-.172l-.368.25a1.099 1.099 0 0 1-1 .109 1.963 1.963 0 0 1-.636-.373L6.14 6.98a2.521 2.521 0 0 1-1.382-.914 2.937 2.937 0 0 1-.407-.848s.042-.178.1-.4a2.308 2.308 0 0 1-.029-.3 2.542 2.542 0 0 0-.536.65c-.11.169-.245.32-.4.449a.807.807 0 0 0-.287.469c-.033.145-.1.391-.208.742a59.659 59.659 0 0 1-.08 1.479l.024.156c.049.285.119.565.21.838.681.855 2.153 2.756 2.5 3.043.175.146.361.276.558.389.137.066.27.129.4.182.192.075.395.115.6.12ZM3.054 9.199Zm4.6-2.641a.778.778 0 0 0 .55.359l.1.014a5.988 5.988 0 0 1-.689-.439c.009.026.023.041.037.067l.002-.001Zm1.727-.172c.242.171.542.237.832.182l.133-.033a.688.688 0 0 0-.277-.23 17.625 17.625 0 0 0-.626-.105h-.014c-.067-.016-.134-.035-.2-.053a.73.73 0 0 0 .15.24l.002-.001Z"
        />
      </svg>
    ),
  },
];

export const shoppingPreferences = [
  {
    value: "salesConsultant",
    label: "Sales Consultant",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M10.249 9.092V8.67c2.309-1.732 1.877-5.315-.777-6.449C6.817 1.087 3.93 3.252 4.275 6.118A3.753 3.753 0 0 0 5.749 8.67v.422a5.284 5.284 0 0 0-3.748 4.834h1c0-2.325 2.243-4.218 5-4.218s5 1.893 5 4.218h1a5.284 5.284 0 0 0-3.752-4.834Zm-5-3.416c0-2.117 2.291-3.44 4.125-2.382 1.833 1.059 1.833 3.705 0 4.763a2.76 2.76 0 0 1-1.373.369 2.752 2.752 0 0 1-2.75-2.75h-.002Z"
        />
      </svg>
    ),
  },
  {
    value: "inStore",
    label: "In-Store",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M2.387 14.404a.4.4 0 0 1-.4-.406V7.316a1.933 1.933 0 0 1-.633-1.441V4.623a.413.413 0 0 1 .034-.164s.01-.02.02-.033l1.5-2.625a.398.398 0 0 1 .348-.2h9.5a.397.397 0 0 1 .348.2l1.5 2.629a.16.16 0 0 0 .015.029v.02h.034v1.4a1.94 1.94 0 0 1-.638 1.441v6.682a.4.4 0 0 1-.4.406l-11.228-.004Zm8.6-5.27a.4.4 0 0 1 .4.4v4.063h1.823V7.765a1.96 1.96 0 0 1-2.089-.705 1.96 1.96 0 0 1-1.562.779 1.96 1.96 0 0 1-1.562-.779 1.96 1.96 0 0 1-1.562.779 1.96 1.96 0 0 1-1.562-.779 1.96 1.96 0 0 1-2.089.705v5.832h1.823V9.535a.4.4 0 0 1 .4-.4l5.98-.001Zm-5.575 4.463h5.173v-3.66H5.412v3.66Zm6.111-7.723c.002.64.52 1.159 1.161 1.162a1.163 1.163 0 0 0 1.16-1.162v-.846h-2.321v.846Zm-3.123 0c.002.64.52 1.159 1.16 1.162.308 0 .604-.122.822-.34.217-.219.338-.515.338-.822v-.846H8.399l.001.846Zm-3.124 0c.002.64.52 1.159 1.161 1.162.308 0 .604-.123.822-.34.217-.219.338-.515.338-.822v-.846H5.276v.846Zm-3.123.016c.01.634.526 1.143 1.16 1.146.308 0 .604-.123.822-.34.217-.219.339-.514.339-.822v-.846H2.153v.862Zm9.269-1.664h2.132L12.51 2.4h-1.639l.551 1.826Zm-3.022 0h2.185L10.034 2.4H8.4v1.826Zm-2.983 0h2.181V2.4H5.964l-.547 1.826Zm-2.973 0h2.132L5.127 2.4H3.488L2.444 4.226Z"
        />
      </svg>
    ),
  },
  {
    value: "online",
    label: "Online",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={16}
        height={16}
      >
        <path
          fill="#8f95a5"
          d="M5.001 9.426h9V5.593L6.009 3.451l-.128-.017-1.38-.008v-1.5h-2.5v1h1.5v8.5h.89a1.5 1.5 0 1 0 2.22 0h4.28a1.5 1.5 0 1 0 2.22 0h.89v-1h-9.5v-.5l.5-.5Zm.5 3.5a.5.5 0 1 1 .002-1.001.5.5 0 0 1-.002 1.001Zm6.5 0a.5.5 0 1 1 .002-1.001.5.5 0 0 1-.002 1.001Zm-7.5-8.5h1.312l7.188 1.934v2.066h-8.5v-4Z"
        />
      </svg>
    ),
  },
  {
    value: "noPreferences",
    label: "No Preferences",
    icon: "",
  },
];
